import type { WiwState } from '@/store';

export const getReportSize = (state: WiwState): number | undefined => state.reporting.customReportBuilder.reportSize;
